var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LegalAgreements',{attrs:{"title":_vm.$t('labels.termsandconditions'),"get-url":"/admin/agreement/terms-and-conditions","post-url":"/admin/agreement/terms-and-conditions"}})}
var staticRenderFns = []

export { render, staticRenderFns }